"use client";

import { useQuery } from "@tanstack/react-query";

import { customInstance } from "@/lib/api/client";

import { projectSequencesQueryKey } from "./use-project-sequences";

export interface SequenceFilterJob {
  job_id: string;
  job_name: string;
}

interface FilterJobsPayload {
  jobs: SequenceFilterJob[];
}

/**
 * Jobs in the project that have ≥1 sequence — for the Sequences sheet
 * Job filter dropdown (excludes empty jobs).
 */
export function useProjectSequenceFilterJobs({
  projectId,
  enabled = true,
}: {
  projectId: string | null | undefined;
  enabled?: boolean;
}) {
  const query = useQuery({
    queryKey: [
      ...projectSequencesQueryKey(projectId),
      "filter-jobs",
    ],
    queryFn: () =>
      customInstance<FilterJobsPayload>(
        `/api/projects/${projectId}/sequences/filter-jobs`,
        { method: "GET" },
      ),
    enabled: !!projectId && enabled,
  });

  return {
    jobs: query.data?.jobs ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
